import * as React from 'react'
import { translation, translationForTipos } from 'easit--localization';

export const OddListHeaderForTipos: React.FC = () => {
    return (
        <>
            <div className="bet-info header-col flex-grow-1 px-2 text-left">
                {translation().match}
            </div>
            <div className="tip-name header-col text-center ">
                {translation().bet}
            </div>
            <div className="rate-value header-col text-center">
                {translation().rate}
            </div>
            <div className="result-text header-col text-center">
                {translationForTipos().results}
            </div>
            <div className={"result-img header-col"}></div>
        </>
    );
};
